import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toDate, format } from 'date-fns';
import { classnames } from 'Utils/classnames';
let counterInterval;

class Counter extends Component {

  static propTypes = {
    start: PropTypes.bool,
    duration: PropTypes.number,
    timeIsOver: PropTypes.func,
    showIndicator: PropTypes.bool,
  };

  static defaultProps = {
    showIndicator: true,
  };

  constructor (props) {
    super(props);

    this.state = {
      countdownDuration: props.duration || 90,
      isCounterActive: false,
      isTimeOver: false,
      remainingTime: ''
    };
  }

  componentDidMount () {
    this.startCounter();
  }

  componentWillUnmount () {
    clearInterval(counterInterval);
  }

  startCounter = () => {
    let seconds = this.state.countdownDuration;

    this.setState({
      isCounterActive: true,
      isTimeOver: false,
    }, () => {
      counterInterval = setInterval(() => {

        if (seconds > 0) {

          seconds--;

          this.setState({ remainingTime: seconds });

        } else {
          this.stopCounter();
        }
      }, 1000);
    });
  };

  stopCounter = () => {
    this.setState({
      isTimeOver: true,
      isCounterActive: false
    }, () => {

      clearInterval(counterInterval);
      this.props.timeIsOver();
    });
  };

  render () {
    const { isCounterActive, countdownDuration, remainingTime, isTimeOver } = this.state;

    const componentClasses = classnames({
      progress: true,
      'progress--start': isCounterActive
    });

    const animationDuration = {
      animationDuration: `${ countdownDuration }s`,
      animationPlayState: 'running'
    };

    const otpCounterTextClassName = classnames({
      otp__counter__text: true,
      'otp__counter__text--over': isTimeOver,
    });

    return (
      <div className='otp__counter'>
        {
          this.props.showIndicator
          && <div className='otp__counter__icon'>
            <svg className={ componentClasses } width='120' height='120' viewBox='0 0 120 120'>
              <circle cx='60' cy='60' r='54' fill='none' stroke='#e6e6e6' strokeWidth='6' />
              <circle className='progress__value' cx='60' cy='60' r='54' fill='none' stroke='#ff015b' strokeWidth='6' style={ animationDuration } />
            </svg>
          </div>
        }
        <div className={ otpCounterTextClassName }>
          Kalan Süre: <strong> { format(toDate(remainingTime * 1000), 'mm:ss') } </strong>
        </div>
      </div>
    );
  }
}

export default Counter;
